<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <span> Sync </span> /
      <span> Select Method </span>
    </nav>
    <sync-steps :method="selectedCard"></sync-steps>

    <h2 class="flow-heading pt-5 mt-5">Which would you like to sync with {{ crmName }}?</h2>
    <flow-card-group :cards="cards" @selected="onSelected" :selected="selectedCard"></flow-card-group>
    <form :action="formAction" method="POST" class="text-center mb-2">
      <input type="hidden" name="method" :value="selectedCard" />
      <a class="btn btn-lg btn-outline-primary mr-2" href="/inventory/contacts/groups/">Back</a>
      <button type="submit" class="btn btn-lg btn-primary" :disabled="!selectedCard">Continue</button>
    </form>
  </div>
</template>

<script>
import SyncSteps from '../components/sync/SyncSteps';
import FlowCardGroup from '../components/shared/FlowCardGroup';
import {getCommercialName} from '../utility/crms/getCommercialName.js';

export default {
  name: 'sync-select-method-page',
  components: {
    SyncSteps,
    FlowCardGroup,
  },
  props: {
    activeCrm: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedCard: null,
    };
  },
  methods: {
    onSelected(id) {
      this.selectedCard = id;
    },
  },
  computed: {
    cards() {
      return [
        // {
        //   id: 'all',
        //   name: 'Sync All Contacts',
        //   description: 'Sync all contacts and their assigned groups.',
        //   iconClass: 'fas fa-file-alt',
        //   disabled: false,
        // },
        {
          id: 'groups',
          name: 'Sync Groups',
          description: 'Sync only selected groups of contacts.',
          iconClass: 'fa fa-th',
          disabled: false,
        },
      ];
    },
    formAction() {
      return this.selectedCard === 'groups' ? '/sync/select-groups' : '/sync/confirm';
    },
    crmName() {
      return getCommercialName(JSON.parse(this.activeCrm).crm_name);
    },
  },
};
</script>
